<template>
  <section>
    <p class="has-text-weight-bold mb-2">Sales history</p>

    <!--  <b-field
         grouped
         group-multiline
         class="field"
         :class="{ 'is-invisible': !checkedRows.length }"
       >
         <b-button
           label="Clear selection"
           type="is-danger"
           icon-left="times"
           @click="checkedRows = []"
           class="mr-2"
         />
         <b-button
           label="Close day"
           :loading="closing"
           type="is-primary"
           :disabled="!checkedRows.length"
           @click="closeDay"
         />
       </b-field> -->

    <b-table
      class="pt-4 table-container"
      :data="passes"
      ref="table"
      paginated
      per-page="10"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      pagination-rounded
    >
      <b-table-column field="date" label="Date" sortable v-slot="props">
        {{ props.row.date }}
      </b-table-column>

      <b-table-column
        field="ticketsSold"
        label="Passes sold"
        sortable
        v-slot="props"
      >
        <b-tag type="is-success">{{ props.row.ticketsSold }}</b-tag>
      </b-table-column>

      <template #empty>
        <div class="has-text-centered">We haven't sold any tickets yet</div>
      </template>
    </b-table>
  </section>
</template>

<script>
import { db } from "../firebase";
export default {
  data() {
    return {
      isLoading: true,
      passes: [],
      storedSalesHistory: [],
    };
  },
  created() {
    this.getBoughtPasses();
  },
  methods: {
    getBoughtPasses() {
      db.firestore()
        .collection("passes")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (!doc.data().expectedDateOfUse || doc.data().isTest) return;
            if (Date.now() > doc.data().expectedDateOfUse) return
            this.passes.push(doc.data());
          });
          this.processTableData()
        })
        .catch((err) => {
          this.$buefy.toast.open({
            duration: 10000,
            message: err.message,
            position: "is-bottom",
            type: "is-danger",
          });
        });
    },
    processTableData() {
      function convertTimestamp(timestamp) {
        if (typeof timestamp === "number" || !isNaN(Number(timestamp))) {
        return new Date(Number(timestamp)); // Convert Unix timestamp to Date
    }

      }

      // Format date as DD-MM-YYYY
      function formatDate(dateObj) {
        const day = String(dateObj.getDate()).padStart(2, "0");
        const month = String(dateObj.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
      }
      // Sort by date
      this.passes.sort(
        (a, b) =>
          convertTimestamp(a.expectedDateOfUse) -
          convertTimestamp(b.expectedDateOfUse)
      );

      // Group sales by date
      const groupedSales = this.passes.reduce((acc, sale) => {
        const dateObj = convertTimestamp(sale.expectedDateOfUse);
        const date = formatDate(dateObj); // Convert to DD-MM-YYYY

        if (!acc[date]) {
          acc[date] = {  ticketsSold: 0 };
        }
        // Count tickets sold
        acc[date].ticketsSold += sale.tickets.length;
        return acc;
      }, {});

      console.log(groupedSales);
      this.passes = Object.entries(groupedSales).map(([date, data]) => ({
        date,
        ticketsSold: data.ticketsSold,
      }));
    },
  },
};
</script>
